/* eslint-disable @typescript-eslint/ban-ts-comment */
// oxlint-disable no-unused-vars
/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { type Meta, type StoryObj } from '@storybook/react-vite';

import { TextOverflow } from '../TextOverflow';
import {
  CharacterLimitSrc,
  ExpandCollapseButtonsSrc,
  LineClampSrc,
  MixedContentSrc,
  TextOverflowCharacterLimit,
  TextOverflowExpandCollapseButtons,
  TextOverflowLineClamp,
  TextOverflowMixedContent,
  TextOverflowWidthBasedTruncation,
  WidthBasedTruncationSrc,
} from '.';

const componentMeta: Meta<typeof TextOverflow> = {
  component: TextOverflow,
  id: 'components-text-overflow',
  parameters: {
    controls: { disable: true },
  },
  tags: ['docsPage'],
  title: 'Components/TextOverflow',
};

export default componentMeta;
type Story = StoryObj<typeof componentMeta>;

// @ts-ignore
const CharacterLimit: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: CharacterLimitSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: TextOverflowCharacterLimit,
};

// @ts-ignore
const ExpandCollapseButtons: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: ExpandCollapseButtonsSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: TextOverflowExpandCollapseButtons,
};

// @ts-ignore
const LineClamp: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: LineClampSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: TextOverflowLineClamp,
};

// @ts-ignore
const MixedContent: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: MixedContentSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: TextOverflowMixedContent,
};

// @ts-ignore
const WidthBasedTruncation: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: WidthBasedTruncationSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: TextOverflowWidthBasedTruncation,
};

// TODO: don't export until we want to release TextOverflow
// export {
//   CharacterLimit,
//   ExpandCollapseButtons,
//   LineClamp,
//   MixedContent,
//   WidthBasedTruncation,
// };
